'use client';

import { Environment } from '@coolblue-development/constants';
import { Box } from '@coolblue-development/freddy';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

export const IntersectionWrapper = ({ children, id }: { children: ReactNode; id?: string }) => {
  const [show, setShow] = useState<boolean>(false);
  const { ref, inView } = useInView({ rootMargin: '250px 0px', triggerOnce: true });
  const { environment } = useRequestContext();

  useEffect(() => {
    if (!inView) return;
    setShow(true);
  }, [inView]);

  if (environment === Environment.CI || environment === Environment.DEVELOPMENT)
    return <Box id={id}>{children}</Box>;

  return (
    <Box ref={ref} {...(id && { id: id })}>
      {/* Keep a minimal placeholder so the observer target is not empty before lazy content mounts. */}
      {show ? children : <span />}
    </Box>
  );
};
